export const mufflerBands = [
  {
    id: 'MUF001',
    name: '28751-7C1000',
    description: '트럭 11톤 - 25톤',
    category: '트럭용 소음기 반도/벤딩',
    price: 15000,
    image: 'https://public.readdy.ai/ai/img_res/e7c417a855d7b49ead1da57613962510.jpg',
    inStock: true,
    partNumber: '28751-7C1000',
    compatibility: ['트럭 11톤', '트럭 25톤']
  },
  {
    id: 'MUF002',
    name: '28751-6B2000',
    description: '메가트럭 파비스',
    category: '트럭용 소음기 반도/벤딩',
    price: 14000,
    image: 'https://readdy.ai/api/search-image?query=Premium%20quality%20muffler%20band%20clamp%20for%20Mega%20Truck%20and%20Pavise%20models%2C%20durable%20steel%20construction%20with%20corrosion%20resistant%20coating%20on%20plain%20white%20background%2C%20automotive%20exhaust%20system%20part%20professional%20studio%20shot&width=400&height=400&seq=muf002&orientation=squarish',
    inStock: true,
    partNumber: '28751-6B2000',
    compatibility: ['메가트럭', '파비스']
  },
  {
    id: 'MUF003',
    name: '28751-7E000',
    description: '트라고9.5톤 버스',
    category: '트럭용 소음기 반도/벤딩',
    price: 16000,
    image: 'https://readdy.ai/api/search-image?query=Heavy%20duty%20muffler%20exhaust%20band%20clamp%20for%20Trago%209.5%20ton%20bus%2C%20robust%20steel%20construction%20with%20secure%20fastening%20system%20on%20clean%20white%20background%2C%20commercial%20vehicle%20exhaust%20component%20professional%20product%20image&width=400&height=400&seq=muf003&orientation=squarish',
    inStock: true,
    partNumber: '28751-7E000',
    compatibility: ['트라고 9.5톤', '버스']
  },
  {
    id: 'MUF004',
    name: '28751-5K000',
    description: 'E마이티, E카운티',
    category: '트럭용 소음기 반도/벤딩',
    price: 13000,
    image: 'https://readdy.ai/api/search-image?query=Muffler%20band%20clamp%20for%20E-Mighty%20and%20E-County%20trucks%2C%20precision%20engineered%20steel%20exhaust%20system%20component%20with%20polished%20finish%20on%20white%20background%2C%20automotive%20parts%20professional%20photography&width=400&height=400&seq=muf004&orientation=squarish',
    inStock: true,
    partNumber: '28751-5K000',
    compatibility: ['E마이티', 'E카운티']
  }
];